module.exports = __webpack_public_path__ + "static/img/TO-2020.8a830fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/TO-2020.png
// module id = IYV/
// module chunks = 0